module.exports = __webpack_public_path__ + "static/media/Project_Proposal.32c827ac.pdf";